import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { forwardRef } from 'preact/compat';
import { BRAND_CLASSES } from '@/constants/theme';
/**
 * Common Checkbox component for boolean form fields.
 * Integrates with React Hook Form via forwardRef.
 *
 * @example
 * ```tsx
 * <Checkbox
 *   label="Require confirmation"
 *   description="Users must explicitly confirm"
 *   error={errors.requireConfirmation?.message}
 *   {...register('requireConfirmation')}
 * />
 * ```
 */
export const Checkbox = forwardRef(({ label, description, required, error, containerClassName, ...props }, ref) => {
    return (_jsxs("div", { className: containerClassName, children: [_jsxs("label", { className: "flex items-start gap-3 cursor-pointer group", children: [_jsx("input", { ref: ref, type: "checkbox", ...props, className: `mt-0.5 h-4 w-4 rounded border-slate-300 dark:border-slate-600 ${BRAND_CLASSES.FOCUS.PRIMARY} text-primary-600 dark:text-primary-500` }), (label || description) && (_jsxs("div", { className: "flex-1", children: [label && (_jsxs("span", { className: "text-sm font-medium text-slate-900 dark:text-white", children: [label, required && _jsx("span", { className: BRAND_CLASSES.INPUT.REQUIRED, children: " *" })] })), description && (_jsx("p", { className: "text-xs text-slate-500 dark:text-slate-400 mt-0.5", children: description }))] }))] }), error && (_jsx("p", { className: `mt-1 text-sm ${BRAND_CLASSES.INPUT.ERROR_TEXT}`, children: error }))] }));
});
Checkbox.displayName = 'Checkbox';
